import { FC } from 'react'
import { Route, Switch, useRouteMatch, Redirect } from 'react-router-dom'
import { Tab } from './'
import { Divider } from 'components/Divider/Divider'

interface TabRoutesProps {
  config: TabRouteConfig
}

export interface TabRouteConfig {
  tabConfig: TabConfig[]
  defaultRedirect: string
}
export interface TabConfig {
  route: string
  label: string
  content: React.ReactNode
}

export const TabRoutes: FC<TabRoutesProps> = ({ config }) => {
  const match = useRouteMatch()
  const matchedPath = match.path !== '/' ? match.path : ''

  return (
    <>
      {config.tabConfig.slice(0, config.tabConfig.length).map((tab, index) => (
        <Tab to={`${matchedPath}/${tab.route}`} key={index} className='my-tab ds-u-margin-right--4 ds-u-font-size--lg'>{tab.label}</Tab>
      ))}
      <Divider />
      <Switch>
        {config.tabConfig.slice(0, config.tabConfig.length).map((tab, index) => (
          <Route path={`${matchedPath}/${tab.route}`} render={() => tab.content} key={index} />
        ))}
        <Route exact path={`${matchedPath}/`}><Redirect to={`${matchedPath}/${config.defaultRedirect}`} /></Route>
      </Switch>
    </>
  )
}
